import {
  BodyLinkV3,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';

import PageLayoutV3 from '@/app/components/PageLayoutV3';

const Page = () => {
  return (
    <PageLayoutV3
      pageName="Terms and Conditions"
      containerProps={{ name: 'terms-and-conditions', padding: 'both' }}
      footerProps={{
        wrapperClassName: 'bg-white',
      }}
    >
      <LayoutGrid data-cy="terms-and-conditions-sv-page">
        <TypographyRhythm className="col-main">
          <TypographyV3 Element="h1" variant="h1">
            ŌURA ANVÄNDARVILLKOR
          </TypographyV3>
          <BodyLinkV3 color="inherit" href="/sv/gen2-terms-and-conditions">
            Tidigare villkor och bestämmelser
          </BodyLinkV3>
          <TypographyV3>
            <em>Senast uppdaterat: 2 april 2024</em>
          </TypographyV3>
          <TypographyV3>
            Välkommen och tack för ditt intresse för Ōura! Dessa användarvillkor
            ("avtalet") beskriver de villkor som gäller för din användning av
            ouraring.com/sv ("webbplatsen"), Smart Ring, laddaren och/eller
            andra elektroniska enheter ("produkterna" ), inklusive
            Ōura-mobilappen ("mobilappen") (tillsammans "tjänsterna").
            Webbplatsen och mobilappen ägs och drivs av Ōura Health Oy, och dess
            närstående företag och dotterbolag, såsom Ouraring Inc. (tillsammans
            "Ōura" eller "Oura").
          </TypographyV3>
          <TypographyV3>
            I detta avtal hänvisar vi till oss själva som "Ōura" eller "Oura"
            eller "oss" eller "vi"; vi hänvisar till dig som "du" eller "Kund".
            Oura och kunden hänvisas till i detta avtal individuellt som en
            "part" och tillsammans som "parterna".
          </TypographyV3>
          <TypographyV3>
            Genom att komma åt eller använda tjänsterna, inklusive åtkomst till
            webbplatsen, avser och samtycker du uttryckligen till att vara
            bunden av alla villkor och bestämmelser i detta avtal och
            integritetspolicyn (tillgänglig på{' '}
            <BodyLinkV3 color="inherit" href="/sv/privacy-policy">
              ouraring.com/privacy-policy
            </BodyLinkV3>{' '}
            ), som införlivas genom hänvisning. Om du inte godkänner dessa
            villkor får du inte använda tjänsterna.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Åtkomst och användning
          </TypographyV3>
          <TypographyV3>
            Oura ger dig en begränsad licens för åtkomst till webbplatsen enligt
            detta avtal. Om du väljer att prenumerera på och använda mobilappen,
            ger Oura dig vidare en licens att få tillgång till och använda
            tjänsterna, under förutsättning att du följer detta avtal,
            integritetspolicyn och alla andra regler och krav som kommuniceras
            till dig av Oura, inklusive din betalning av eventuella tillämpliga
            avgifter. Du bekräftar och godkänner att Oura kan modifiera,
            uppdatera och på annat sätt ändra tjänsterna när som helst och efter
            eget gottfinnande.
          </TypographyV3>
          <TypographyV3>
            Du intygar och garanterar att du är minst 18 år gammal och har
            laglig rätt att godkänna detta avtal för din räkning eller på
            uppdrag av någon part som du representerar. Du är ensam ansvarig för
            dina aktiviteter och din interaktion med tjänsterna.
          </TypographyV3>
          <TypographyV3>
            Du ska inte använda tjänsterna för några syften utöver omfattningen
            av den åtkomst som beviljas i detta avtal. Du ska inte vid något
            tillfälle, direkt eller indirekt, och inte ge någon tredje part rätt
            att: (i) kopiera, modifiera eller skapa härledda verk av tjänsterna,
            helt eller delvis; (ii) bakåtkonstruera, demontera, dekompilera,
            avkoda, anpassa eller på annat sätt försöka härleda eller få åtkomst
            till någon mobilappskomponent i tjänsterna, helt eller delvis; eller
            (iii) använda tjänsterna på något sätt eller för något ändamål som
            gör intrång i, missbrukar eller på annat sätt kränker någon persons
            immateriella rättigheter eller andra rättigheter (inklusive men inte
            begränsat till webbskrapning), eller som på annat sätt bryter mot
            någon lag, förordning, eller andra lagkrav.
          </TypographyV3>
          <TypographyV3>
            Köp är endast avsedda för dig som slutanvändare och är inte godkända
            för återförsäljning utan Ouras uttryckliga tillstånd. Vi förbehåller
            oss rätten att vägra eller annullera din beställning om vi
            misstänker att du köper tjänster för återförsäljning.
          </TypographyV3>
          <TypographyV3>
            Förutom den begränsade licensen för åtkomst till webbplatsen och
            mobilappen som identifieras ovan, godkänner du att ingenting i detta
            avtal ska tolkas som att det beviljar eller ger, genom
            underförstått, estoppel eller på annat sätt, någon rättighet, titel
            eller intresse för all immateriell egendom, inklusive eventuella (i)
            uppfinningar (oavsett om de är patenterbara eller inte i något
            land), patent, patentansökningar, avslöjande av uppfinningar,
            förbättringar, affärshemligheter, proprietär information, know-how,
            information eller teknisk data; (ii) upphovsrättsskyddade verk,
            upphovsrättsregistreringar, maskverk, registreringar av maskverk
            eller applikationer i USA eller något främmande land; (iii)
            varumärken, varumärkesregistreringar, servicemärken, logotyper eller
            applikationer för dessa i USA eller något främmande land; (iv)
            företagshemligheter. eller (v) andra materiella eller immateriella
            äganderätter var som helst i världen.
          </TypographyV3>
          <TypographyV3>
            Du bekräftar och godkänner att tjänsterna ibland inte kan kommas åt
            eller användas av någon anledning, inklusive, utan begränsning: (i)
            utrustningsfel; (ii) periodiska underhållsprocedurer eller
            reparationer som Oura kan utföra från tid till annan utan att
            meddela dig; eller (iii) orsaker som ligger utanför Ouras kontroll
            eller som inte är rimligen förutsebara.
          </TypographyV3>
          <TypographyV3>
            Utan hinder av något annat som anges i detta avtal, kan Oura
            tillfälligt stänga av åtkomsten till de tjänster som tillhandahålls
            dig och andra tredje parter av säkerhetsskäl, för att förhindra
            olaglig eller bedräglig aktivitet, för att följa juridiska krav från
            någon myndighet eller statlig enhet, eller om du bryter mot avtalet
            eller integritetspolicyn.
          </TypographyV3>
          <TypographyV3>
            Oura kan från tid till annan och efter eget gottfinnande anlita
            andra tjänsteleverantörer för att hjälpa till med utförandet av
            tjänsterna, såsom webbhotelleverantörer, betalningsprocessorer och
            andra tredje parter. Du ska följa användarvillkoren och andra krav
            som är förknippade med tjänsterna som tillhandahålls av sådana
            tredje parter i samband med tjänsterna.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Kundens ansvar
          </TypographyV3>
          <TypographyV3>
            Du godkänner att du är ensam ansvarig för din användning av
            tjänsterna, direkt eller indirekt, inklusive förståelse för huruvida
            sådan åtkomst eller användning är tillåten av eller strider mot
            detta avtal. Du är vidare ensam ansvarig för att följa alla
            tillämpliga lagar som rör din användning av tjänsterna. Du ska
            vidare använda tjänsterna enbart för lagliga syften och bedriva all
            verksamhet genom tjänsterna i enlighet med tillämpliga lagar och
            förordningar, inklusive men inte begränsat till alla tillämpliga
            federala och statliga lagar och förordningar som reglerar erbjudande
            och försäljning av värdepapper, penningtvätt och bekämpning av
            terrorism.
          </TypographyV3>
          <TypographyV3>
            Du är ensam ansvarig för att säkerställa och vidhålla att du kan
            komma åt och använda tjänsterna, inklusive genom att säkra din egen
            kompatibla hårdvara, mobilapp, internetåtkomst, säkerhetsmobilapp,
            säkerhetskopieringsenheter eller tjänster och alla andra krav. Oura
            har inget ansvar för att tillhandahålla ytterligare mobilappar eller
            hårdvara. Du samtycker vidare till att Oura inte ska ha något ansvar
            för dataförlust eller annan skada eller förlust som uppstår i
            samband med din användning av tjänsterna, inklusive eventuell
            underlåtenhet att tillhandahålla tillräcklig säkerhet eller enheter
            eller tjänster för säkerhetskopiering.
          </TypographyV3>
          <TypographyV3>
            Du ansvarar för att Oura har korrekt och aktuell information för
            ditt kundkonto, inklusive aktuell kontakt- och
            betalningsinformation. Du är vidare ansvarig för att regelbundet
            granska det tillhörande e-postkontot för kunder för att kunna ta
            emot meddelanden från Oura.
          </TypographyV3>
          <TypographyV3>
            Om du förses med ett användarnamn, lösenord, referensfil eller någon
            annan information som en del av en säkerhetsprocedur
            ("Inloggningsuppgifter"), måste du behandla sådan information som
            konfidentiell och får inte lämna ut inloggningsuppgifter till någon
            annan person eller enhet. Du bekräftar att ditt konto och dina
            uppgifter är personliga för dig och samtycker vidare till att inte
            ge någon annan person tillgång till tjänsterna eller delar av
            tjänsterna med ditt användarnamn, lösenord eller annan
            säkerhetsinformation. Du ska omedelbart meddela Oura vid eventuell
            obehörig åtkomst till eller användning av dina inloggningsuppgifter
            eller andra säkerhetsbrott. Oura har rätt att när som helst
            inaktivera användarnamn, lösenord, referensfiler eller annan
            identifierare, oavsett om uppgifterna valts av dig eller
            tillhandahållits av Oura.
          </TypographyV3>
          <TypographyV3>
            Oura ska göra kommersiellt rimliga ansträngningar för att
            tillhandahålla lämpliga supporttjänster för tjänsterna. Utan hinder
            av vad som sägs ovan ger detta avtal dig inte rätt till någon
            garanterad nivå, tillgänglighet eller handläggningstid när det
            gäller supporttjänster för tjänsterna.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Betalning och avgifter
          </TypographyV3>
          <TypographyV3>
            Betaltjänster inkluderar tjänsterna, som kan vara engångsköp eller
            automatiskt förnyande av prenumerationstjänster ("betaltjänster"),
            inklusive vår webbplats och mobilapp ("prenumerationer"). Vi kan
            göra ändringar i, stänga av eller avbryta betaltjänster när som
            helst av vilken anledning som helst, och Oura förbehåller sig rätten
            att avgöra vilka tjänster eller delar av dessa som kräver betalning.
          </TypographyV3>
          <TypographyV3>
            Betaltjänster kan innehålla förbeställda produkter som kommer att
            produceras åt dig i framtiden ("förbeställning"). Du kommer att
            debiteras en förbeställningsavgift när du gör din förbeställning.
            Det faktiska datumet för leverans av en godkänd förbeställning beror
            på en mängd olika faktorer, inklusive men inte begränsat till
            datumet för betalningen av din förbeställningsavgift och Ouras
            tillverkningsschema. Det finns ingen garanti för leveransdatum för
            förbeställningar.
          </TypographyV3>
          <TypographyV3>
            Du samtycker till att betala alla tillämpliga avgifter för
            betaltjänster inklusive, utan undantag, eventuella månatliga
            prenumerationsavgifter, användaravgifter och erbjudandeavgifter och
            alla andra avgifter, avgifter eller kostnader som du samtycker till
            att köpa som en del av betaltjänsterna under utcheckningsprocessen
            ("avgifter"). Du samtycker till att betala alla avgifter och alla
            tillämpliga skatter som uppkommit före uppsägning eller uppsägning
            av avtalet.
          </TypographyV3>
          <TypographyV3>
            Du godkänner att Oura debiterar dig enligt din angivna
            betalningsmetod för betaltjänster. Genom att tillhandahålla en
            godtagbar betalningsmetod intygar och garanterar du att du har rätt
            att använda den angivna betalningsmetoden och att du ger oss eller
            vår tredje parts betalningsbehandlare rätt att debitera din
            betalningsmetod för det totala beloppet för ditt köp, inklusive
            eventuella tillämpliga skatter och andra avgifter. Om
            betalningsmetoden inte kan verifieras, är ogiltig eller på annat
            sätt inte är godtagbar, kan din betaltjänst stängas av eller
            avbrytas. Du måste åtgärda alla problem vi stöter på i samband med
            den betalningsmetod du tillhandahåller för att kunna fortsätta med
            din användning av tjänsten. Om du godkänner ett kampanjerbjudande
            eller gör ändringar i dina betaltjänster kan avgifterna, skatterna
            och de debiterade beloppen variera. Faktureringsbeloppen kan också
            variera på grund av ändringar i tillämpliga skatter eller
            valutakurser. Du samtycker till att vi eller vår tredje parts
            betalningsbehandlare debiterar dig enligt din betalningsmetod för
            motsvarande belopp. Återbetalningar kommer inte att utfärdas om det
            inte krävs enligt lag. Individuella rabatter får inte kombineras
            eller ackumuleras med någon annan rabatt. Denna betalningsskyldighet
            ska fortsätta att gälla efter uppsägning eller uppsägning av detta
            avtal oavsett orsak.
          </TypographyV3>
          <TypographyV3>
            Om du väljer att finansiera ett köp genom vår tredje parts
            betalningsprocessor och en eller flera varor i din beställning har
            ett förlängt leveransdatum, kan dina avbetalningar, inklusive ränta,
            förfalla innan vi skickar alla beställningar. Observera att du inte
            kan få rabatt på redan upplupen ränta för ett belopp som senare
            återbetalas.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Prenumerationer
          </TypographyV3>
          <TypographyV3>
            Vissa betaltjänster är prenumerationsbaserade köp för vilka följande
            villkor gäller:
          </TypographyV3>
          <TypographyV3>
            <b>
              Din prenumerationsperiod kan variera som en kontinuerlig, månatlig
              eller årlig period ("prenumerationsperiod(er)"), enligt
              beskrivningen under köpet av de betalda tjänsterna. Din
              prenumeration kommer att förnyas automatiskt för ytterligare
              prenumerationsvillkor tills din prenumeration avbryts av dig,
              eller avbryts eller avslutas av Oura. Om inte annat anges av oss
              kommer du att debiteras enligt din angivna betalningsmetod före,
              eller i början av, varje prenumerationsperiod för
              prenumerationsavgiften plus eventuella tillämpliga skatter och
              andra avgifter. Innan vi debiterar dig för en prenumerationsperiod
              kommer vi att meddela dig om tillämpliga avgifter, och förnyelsen
              genomförs till det pris som då gäller för den betalda tjänsten.
            </b>
          </TypographyV3>
          <TypographyV3>
            <b>
              Du kan avbryta din prenumeration när som helst. Din uppsägning
              träder i kraft i slutet av den aktuella prenumerationsperioden.
              För att avbryta din prenumeration och automatiska betalningar,
              klicka på knappen "Avsluta konto" från din kontoskärm eller
              kontakta vårt team genom att besöka support.ouraring.com/sv och
              öppna ett supportärende. Uppsägning berättigar dig inte till
              återbetalning av tidigare inbetalda avgifter och du kommer inte
              att få en proportionell återbetalning under återstoden av
              prenumerationsperioden. Om du säger upp din prenumeration,
              observera att vi fortfarande kan skicka reklammeddelanden till
              dig, såvida du inte väljer bort att ta emot dessa meddelanden
              genom att följa instruktionerna för att avbryta prenumerationen i
              meddelandet.
            </b>
          </TypographyV3>
          <TypographyV3>
            <b>
              När du avbryter en prenumeration avbryter du endast framtida
              avgifter för din prenumeration. Du kommer inte att få någon
              återbetalning för den aktuella prenumerationsperioden som du
              betalat för. Du fortsätter dock att ha full tillgång till
              prenumerationen till slutet av den aktuella
              prenumerationsperioden.
            </b>{' '}
            När som helst av någon anledning kan vi bevilja en återbetalning,
            rabatt eller annan ersättning ("krediter") till några eller alla
            våra användare. Beloppet och formen av sådana krediter, och beslutet
            att bevilja dem, fattas efter vårt eget gottfinnande.
            Tillhandahållande av krediter i ett fall ger dig inte rätt till
            krediter i framtiden för liknande tillfällen, och det förpliktar oss
            inte heller att bevilja krediter i framtiden.
          </TypographyV3>
          <TypographyV3>
            Om du bor utanför USA och ändrar dig angående ditt köp, kan du ha
            rätt att få full återbetalning inom fjorton (14) dagar
            ("ångerrätt"), förutsatt att du inte har loggat in eller på annat
            sätt löst in eller börjat använda tjänsterna som abonnent under
            perioden för ångerrätt.
          </TypographyV3>
          <TypographyV3>
            Från tid till annan kan vi erbjuda gratis provperioder av vissa
            prenumerationer under bestämda tidsperioder utan betalning.{' '}
            <b>
              Innan du startar din kostnadsfria provperiod kommer vi att meddela
              dig om tillämpliga prenumerationsavgifter som kommer att debiteras
              när din kostnadsfria provperiod går ut. Såvida du inte avbryter
              din prenumeration före slutet av din kostnadsfria provperiod genom
              att vidta stegen som beskrivs ovan, när din kostnadsfria
              provperiod upphör, kommer vi eller vår tredje parts
              betalningsprocessor att fakturera dig för din
              prenumerationsavgift, plus eventuella tillämpliga skatter och
              andra avgifter, enligt din angivna betalningsmetod på återkommande
              basis, så länge din prenumeration fortsätter. Du måste avbryta din
              prenumeration före slutet av din kostnadsfria provperiod för att
              undvika avgifter. Anvisningar för att säga upp din prenumeration
              beskrivs ovan.
            </b>
          </TypographyV3>
          <TypographyV3>
            Din betalningsinformation kommer att behandlas och lagras genom en
            tredjeparts betalningsbehandlare. Alla betalda kontoinnehavare måste
            upprätthålla minst en giltig betalningsmetod för betalning av
            avgifter, som beskrivs mer i detalj när du går till kassan. Alla
            avgifter beräknas och faktureras dig på månads- eller årsbasis
            beroende på ditt val och förfaller omedelbart efter mottagandet och
            kan komma att ändras. Du bekräftar att avgifter har en återkommande
            betalningsfunktion och du ansvarar för alla återkommande avgifter
            före uppsägning. Avgifter debiteras enligt den sparade, angivna
            betalningsmetoden som du tillhandahåller en dag före den månatliga
            eller årliga årsdagen av det första köpdatumet.
          </TypographyV3>
          <TypographyV3>
            Om du inte har loggat in eller på annat sätt använt tjänsterna på
            sex (6) månader eller längre efter köp eller mottagande av en
            produkt under en kostnadsfri provperiod, förbehåller vi oss rätten
            att avsluta din prenumeration, avbryta eventuella väntande köp och
            återbetala endast inköpspriset för produkten. Du kommer inte att ha
            rätt till återbetalning för värdet av prenumerationen under den
            kostnadsfria provperioden.
          </TypographyV3>
          <TypographyV3>
            Oura förbehåller sig rätten att när som helst justera avgifterna för
            våra betaltjänster, eller alla funktioner eller delar av våra
            betaltjänster. Du godkänner att Oura kan ändra avgifterna för
            betaltjänster när som helst. Vid sådana ändringar meddelar Oura dig
            via den e-postadress som är kopplad till ditt konto minst trettio
            (30) dagar innan ändringen träder i kraft. Din fortsatta användning
            av tjänsterna anger att du godkänner eventuella ändringar av
            avgifterna. Du är ensam ansvarig för alla tillämpliga skatter och
            kommer att debiteras för skatter när det krävs enligt lag.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Data och kommunikation
          </TypographyV3>
          <TypographyV3>
            Oura kan samla in och bearbeta information om din användning av
            tjänsterna. Du samtycker till Ouras insamling och användning av
            sådan information, samt delning av sådan information med
            tredjepartstjänsteleverantörer i syfte att tillhandahålla,
            marknadsföra och förbättra tjänsterna, och av alla andra skäl som
            beskrivs i integritetspolicyn. All personlig information som samlas
            in av Oura behandlas i enlighet medIntegritetspolicyn.
          </TypographyV3>
          <TypographyV3>
            <b>
              Genom att godkänna villkoren i detta avtal och tillhandahålla din
              kontaktinformation till Oura, ger du ditt uttryckliga samtycke
              till att tillåta Oura, dess dotterbolag och agenter att kontakta
              dig från tid till annan via postadress, telefonnummer eller
              e-postadress som du lämnar till Oura.{' '}
            </b>{' '}
            Ditt samtycke innebär att du samtycker till att bli kontaktad av
            Oura och dess tjänsteleverantörer via telefon, e-post, sms eller
            andra sätt för alla ändamål, inklusive men inte begränsat till
            meddelanden relaterade till tjänsterna och ditt konto,
            prenumerationer, köp, tillgängliga uppgraderingar, fakturerings- och
            betalningshanteringsproblem och telemarketingkommunikation. Sådan
            tillåten kommunikation kan inkludera användning av automatisk
            uppringningsteknik eller användning av förinspelade meddelanden. Du
            är ansvarig för eventuella avgifter som kan komma att faktureras dig
            av din(a) tjänsteleverantör(er) när vi kontaktar dig. Du bekräftar
            vidare att ditt samtycke till det föregående inte är ett villkor för
            att använda Oura-tjänsterna, och om du inte vill ge ditt samtycke
            kan du kontakta oss och begära att bli placerad på en "kontakta
            ej-lista". Du kan också när som helst avanmäla dig från meddelanden
            med hjälp av avanmälningsfunktionen som tillhandahålls i sådana
            meddelanden.
          </TypographyV3>
          <TypographyV3>
            Oura frånsäger sig allt ansvar enligt detta avtal för all
            information som du lämnar till Oura som kan utgöra elektroniska
            patientjournaler eller liknande information som tillhandahålls av
            dig eller en slutanvändare, utan hinder av något annat som anges i
            detta avtal eller som annars krävs av alla tillämpliga federala,
            statliga eller internationella lagar, regler eller förordningar.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Immateriella rättigheter
          </TypographyV3>
          <TypographyV3>
            ŌURA, Ō och OURA är varumärken som tillhör Ōura Health Oy.
            Oura-innehåll, Oura-produkter, Oura-funktioner och -tjänster och vår
            underliggande teknik skyddas av upphovsrätt, varumärken, patent,
            immateriella rättigheter och andra lagar i USA och andra länder.
            Alla rättigheter förbehållna. Du beviljas inte, varken underförstått
            eller på annat sätt, någon licens eller rätt att använda några
            märken som förekommer på, används eller visas i samband med
            tjänsterna ("varumärken"). Tjänsterna kan också innehålla eller
            hänvisa till tredje parts varumärken, handelsnamn, produktnamn och
            logotyper som kan vara registrerade varumärken som tillhör deras
            respektive ägare. Du får under inga omständigheter använda eller
            kopiera något av varumärkena. Ingenting häri ska tolkas som att det
            ger någon licens eller rätt att använda några varumärken som visas i
            samband med tjänsterna utan Ouras uttryckliga skriftliga tillstånd.
          </TypographyV3>
          <TypographyV3>
            Allt innehåll som tillhandahålls i samband med tjänsterna och detta
            avtal, inklusive, men inte begränsat till, webbplatsen, produkten,
            mobilappen, all text, grafik, användargränssnitt, visuella
            gränssnitt, fotografier, bilder/video , elektronisk konst, ljud,
            data, kommunikationsprogram, exekverbar kod, datorkod och data
            (tillsammans "Innehåll") formaterade, organiserade och samlade i en
            mängd olika former, inklusive design, struktur, urval, koordination,
            uttryck , "utseende och känsla", arrangemang, layouter, sidor,
            skärmar och databaser av sådant innehåll, som ingår i innehållet,
            tjänsterna och underliggande teknik, och alla andra
            upphovsrättsskyddade verk som är associerade med tjänsterna
            ("upphovsrättsskyddade verk" ), är exklusivt ägda, kontrollerade
            eller licensierade av eller till Oura och skyddas av amerikanska och
            internationella upphovsrättslagar. Du bekräftar att du inte direkt
            eller indirekt kommer att kopiera, reproducera, modifiera, skapa
            härledda verk från, distribuera eller offentligt visa de
            upphovsrättsskyddade verken utan föregående uttryckligt skriftligt
            tillstånd från Oura.
          </TypographyV3>
          <TypographyV3>
            Om du tillhandahåller någon kommunikation eller material till Oura
            via post, e-post, telefon eller på annat sätt, föreslår eller
            rekommenderar ändringar av tjänsterna, inklusive utan begränsning,
            nya funktioner eller funktionalitet relaterade till dessa, eller
            eventuella kommentarer, frågor, förslag, eller liknande
            ("feedback"), får Oura fritt använda sådan feedback oavsett andra
            skyldigheter eller begränsningar mellan parterna som styr sådan
            feedback. Oura får fritt använda, utan någon tillskrivning eller
            kompensation till någon part, idéer, know-how, koncept, tekniker
            eller andra immateriella rättigheter som ingår i feedbacken, för
            vilket ändamål som helst, även om Oura inte är skyldig att använda
            någon feedback.
          </TypographyV3>
          <TypographyV3>
            Oura respekterar andras immateriella rättigheter och det är vår
            policy att snabbt behandla och granska meddelanden om påstådda
            intrång i upphovsrätten eller andra tillämpliga immateriella lagar.
            Alla meddelanden om påstådda intrång ska skickas till Ouras utsedda
            agent på ip@ouraring.com och måste innehålla följande: (i) en
            underskrift (fysisk eller elektronisk) av upphovsrättsinnehavaren
            eller en person som är behörig att agera på uppdrag av
            upphovsrättsinnehavaren; (ii) en beskrivning av det
            upphovsrättsskyddade verk som du hävdar har gjorts intrång i; (iii)
            en beskrivning av materialet som du hävdar gör intrång och ska tas
            bort eller ges tillgång till för inaktivering, och information som
            är tillräcklig för att låta Ouras administratörer hitta materialet;
            (iv) information som är tillräcklig för att vi ska kunna kontakta
            dig, såsom adress, telefonnummer och e-postadress; (v) ett uttalande
            om att du i god tro anser att användningen av materialet på det sätt
            som klagas över inte är tillåten av upphovsrättsinnehavaren, dess
            ombud eller lagen; och (vi) ett uttalande om att informationen i
            meddelandet är korrekt, och att du intygar att du är
            upphovsrättsinnehavaren eller har behörighet att agera på uppdrag av
            ägaren av en upphovsrätt som påstås ha kränkts.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Garantifriskrivning
          </TypographyV3>
          <TypographyV3>
            TJÄNSTERNA TILLHANDAHÅLLS TILL DIG "I BEFINTLIGT SKICK MED ALLA FEL"
            OCH "SOM TILLGÄNGLIGA" UTAN GARANTIER AV NÅGOT SLAG, OCH OURA OCH
            DESS DOTTERBOLAG, NÄRSTÅENDE FÖRETAG, TJÄNSTEMÄN, DIREKTÖRER,
            ANSTÄLLDA, REPRESENTANTER, AGENTER, PARTNER, OCH LICENSGIVARE
            FRÅNSÄGER SIG HÄRMED ALLA GARANTIER OCH VILLKOR MED AVSEENDE PÅ
            TJÄNSTERNA, VARE SIG UTTRYCKLIGA ELLER UNDERFÖRSTÅDDA OCH FRÅNSÄGER
            SIG UTTRYCKLIGEN ALLA UNDERFÖRSTÅDDA GARANTIER AVSEENDE ÄGANDERÄTT,
            SÄLJBARHET, LÄMPLIGHET FÖR ETT SÄRSKILT ÄNDAMÅL, TILLFREDSSTÄLLANDE
            KVALITET, OCH ICKE-INTRÅNG. OURA GARANTERAR INTE EN HELT
            STÖRNINGSFRI ANVÄNDNING AV TJÄNSTERNA, TILLGÅNG TILL INNEHÅLL, ATT
            FUNKTIONERNA I TJÄNSTERNA KOMMER ATT UPPFYLLA DINA KRAV, ATT
            TJÄNSTERNA KOMMER ATT VARA FRIA FRÅN VIRUS ELLER ANDRA SKADLIGA
            KOMPONENTER, ATT DRIFTEN AV TJÄNSTERNA KOMMER ATT VARA OAVBRUTEN
            ELLER FELFRI, ATT DEFEKTER I TJÄNSTERNA KOMMER ATT KORRIGERAS, ELLER
            ATT FUNKTIONERNA I TJÄNSTERNA KOMMER ATT FUNGERA MED ANDRA
            MOBILAPPAR ELLER HÅRDVARA, ELLER INOM ETT SYSTEM. INGEN MUNTLIG
            ELLER SKRIFTLIG INFORMATION ELLER RÅD SOM LÄMNAS AV OURA ELLER EN
            AUKTORISERAD REPRESENTANT FÖR OURA UTGÖR NÅGON GARANTI. VISSA
            JURISDIKTIONER TILLÅTER INTE UNDANTAG AV UNDERFÖRSTÅDDA GARANTIER
            ELLER BEGRÄNSNINGAR AV EN KONSUMENTS TILLÄMPLIGA LAGSTADGADE
            RÄTTIGHETER, SÅ OVANSTÅENDE UNDANTAG KANSKE INTE GÄLLER.
          </TypographyV3>
          <TypographyV3>
            UTAN HINDER AV VAD SOM SÄGS OVAN, GARANTERAR OURA DEN URSPRUNGLIGA
            KÖPAREN, I EGENSKAP AV SLUTANVÄNDARE, ATT PRODUKTEN ÄR FRI FRÅN
            DEFEKTER I MATERIAL OCH UTFÖRANDE I ETT (1) ÅR FRÅN INKÖPSDATUMET.
            Om din lokala lag som gäller vid köptillfället kräver en
            garantiperiod som är längre än ett (1) år, ska denna garanti
            förlängas i den utsträckning som krävs enligt sådan lag. Inom
            garantiperioden ska Oura utan kostnad reparera eller byta ut
            komponenter i produkten som inte omfattas av den begränsade
            garantin. Du är ansvarig för alla relaterade transportkostnader.
            Ersättningsprodukter kan vara nya eller renoverade efter eget
            gottfinnande. Denna begränsade garanti gäller inte för (i) normalt
            slitage, inklusive repor och bucklor; (ii) förbrukningsdelar som
            ingår i produkten, såsom batterier, om inte produktskada har
            uppstått på grund av en defekt i material eller utförande; (iii)
            skada som är ett resultat av din underlåtenhet att använda produkten
            i enlighet med instruktionerna som medföljer Ōura-produkten eller
            finns på webbplatsen; (iv) skada till följd av en olycka,
            översvämning, brand, felaktig användning eller missbruk; (v) skada
            som är ett resultat av utförd service, eller skada som härrör från
            manipulering eller ändringar av produkten, av någon som inte är
            auktoriserad av Ōura; eller (vi) användning av produkten med någon
            annan app eller programvara än mobilappen.
          </TypographyV3>
          <TypographyV3>
            Oura behåller den exklusiva rätten att reparera eller byta ut
            produkten, eller erbjuda full återbetalning, efter eget
            gottfinnande. Sådan gottgörelse ska vara din enda och exklusiva
            gottgörelse för eventuella brott mot denna begränsade garanti.
            Reparationer och ersättningar under garantin har en ny garanti som
            är den längsta av nittio (90) dagar eller resten av den ursprungliga
            ett (1) års garanti.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Ansvarsbegränsning
          </TypographyV3>
          <TypographyV3>
            UNDER INGA OMSTÄNDIGHETER KOMMER OURA, DESS DOTTERBOLAG, NÄRSTÅENDE
            FÖRETAG, TJÄNSTEMÄN, DIREKTÖRER, ANSTÄLLDA, REPRESENTANTER, AGENTER,
            PARTNER OCH LICENSGIVARE ATT VARA ANSVARIGA FÖR SKADOR AV NÅGOT
            SLAG, ENLIGT NÅGON RÄTTSLIG GRUND, SOM UPPSTÅR TILL FÖLJD AV ELLER I
            SAMBAND MED DIN ANVÄNDNING, ELLER OFÖRMÅGA ATT ANVÄNDA, TJÄNSTERNA
            ELLER SÅDANA ANDRA WEBBPLATSER ELLER TJÄNSTER ELLER FÖREMÅL SOM
            ERHÅLLS GENOM TJÄNSTERNA, INKLUSIVE EVENTUELLA DIREKTA, INDIREKTA,
            SPECIELLA, OAVSIKTLIGA, FÖLJDSKADOR ELLER STRAFFSKADESTÅND,
            INKLUSIVE MEN INTE BEGRÄNSAT TILL PERSONSKADOR, SMÄRTA OCH LIDANDE,
            KÄNSLOMÄSSIGT LIDANDE, FÖRLUST AV INKOMST, FÖRLUST AV VINST, FÖRLUST
            AV VERKSAMHET ELLER FÖRVÄNTADE BESPARINGAR, FÖRLUST AV
            AFFÄRSMÖJLIGHETER, AFFÄRSAVBROTT, FÖRLUST AV ANVÄNDNING, FÖRLUST AV
            GOODWILL, FÖRLUST AV DATA OCH OAVSETT OM DET ORSAKATS AV EN
            SKADEGÖRANDE HÄNDELSE (INKLUSIVE FÖRSUMLIGHET), AVTALSBROTT ELLER
            ANNAT, ÄVEN OM DETTA HAR KUNNAT FÖRUTSES. DESSA UNDANTAG ELLER
            BEGRÄNSNINGAR GÄLLER OAVSETT OM OURA HAR VARNATS OM MÖJLIGHETEN FÖR
            SÅDANA SKADOR.
          </TypographyV3>
          <TypographyV3>
            DET FÖREGÅENDE PÅVERKAR INTE NÅGOT ANSVAR SOM INTE KAN UTESLUTAS
            ELLER BEGRÄNSAS ENLIGT TILLÄMPLIG LAG. I DEN UTSTRÄCKNING ANSVAR
            INTE KAN UTESLUTAS ELLER BEGRÄNSAS ENLIGT OVAN, SKA OURA UNDER INGA
            OMSTÄNDIGHETER VARA ANSVARIGT FÖR EVENTUELLA SKADESTÅNDSANSPRÅK,
            INOMKONTRAKTUELLT, SKADESTÅND, UTOMKONTRAKTUELLT ELLER ENLIGT NÅGON
            ANNAN RÄTTSLIG GRUND, PÅ MER ÄN 100 USD.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Försiktighetsåtgärder
          </TypographyV3>
          <TypographyV3>
            TJÄNSTERNA ÄR INTE EN MEDICINSK ENHET OCH DU GODKÄNNER UTTRYCKLIGEN
            ATT TJÄNSTERNA INTE INBEGRIPER OURAS TILLHANDAHÅLLANDE AV MEDICINSK
            RÅDGIVNING. TJÄNSTERNA ÄR INTE AVSEDDA ATT DIAGNOSTISERA, BEHANDLA,
            BOTA ELLER FÖREBYGGA NÅGON SJUKDOM ELLER MEDICINSKA TILLSTÅND.
            TJÄNSTERNA TILLHANDAHÅLLS ENDAST FÖR INFORMATIONSSYFTEN OCH KAN INTE
            ERSÄTTA EN LÄKARES ELLER SJUKVÅRDSPERSONALS TJÄNSTER.
          </TypographyV3>
          <TypographyV3>
            TJÄNSTERNA, INKLUSIVE ALL INFORMATION, TEXT, FOTOGRAFIER, BILDER,
            ILLUSTRATIONER, GRAFIK, LJUD-, VIDEO- OCH LJUD-VIDEOKLIPP OCH ANDRA
            MATERIAL, OAVSETT OM DE TILLHANDAHÅLLS AV OSS ELLER TREDJE PART, ÄR
            INTE AVSEDDA ATT UTGÖRA OCH BÖR INTE ANVÄNDAS I STÄLLET FÖR (a) RÅD
            FRÅN DIN LÄKARE ELLER ANNAN VÅRDPERSONAL, (b) ETT BESÖK, SAMTAL
            ELLER KONSULTATION MED DIN LÄKARE ELLER ANNAN VÅRDPERSONAL, ELLER
            (c) INFORMATION SOM FÖREKOMMER PÅ PRODUKTFÖRPACKNINGAR ELLER
            ETIKETTER.
          </TypographyV3>
          <TypographyV3>
            OM DU HAR NÅGRA HÄLSORELATERADE FRÅGOR, RING ELLER KONTAKTA OMGÅENDE
            DIN LÄKARE ELLER ANNAN VÅRDPERSONAL. VID NÖDFALL, RING DIN LÄKARE
            ELLER 911 OMEDELBART. DU BÖR ALDRIG IGNORERA MEDICINSKA RÅD ELLER
            VÄNTA MED ATT KONTAKTA EN LÄKARE PÅ GRUND AV NÅGON INFORMATION I
            TJÄNSTERNA, OCH DU BÖR INTE ANVÄNDA TJÄNSTERNA ELLER NÅGON
            INFORMATION SOM TILLHANDAHÅLLS I TJÄNSTERNA FÖR ATT DIAGNOSTISERA
            ELLER BEHANDLA HÄLSOPROBLEM. ÖVERFÖRING OCH MOTTAGANDE AV TJÄNSTER,
            HELT ELLER DELVIS, ELLER KOMMUNIKATION VIA INTERNET, E-POST ELLER PÅ
            ANNAT SÄTT UTGÖR ELLER SKAPAR INTE EN RELATION MELLAN
            LÄKARE-PATIENT, TERAPEUT-PATIENT ELLER NÅGON ANNAN HÄLSO- OCH
            SJUKVÅRDSRELATERAD RELATION MELLAN DIG OCH OURA.
          </TypographyV3>
          <TypographyV3>
            Du bör alltid rådfråga en läkare innan du gör några ändringar i din
            sömn eller aktivitet baserat på information som tillhandahålls via
            tjänsterna, eller om du har några frågor angående ett medicinskt
            tillstånd. Oura ansvarar inte för några hälsoproblem som kan uppstå
            från information som du får reda på genom tjänsterna. Om du gör
            någon ändring av din sömn eller aktivitet baserat på tjänsterna,
            samtycker du till att du gör det helt på egen risk. Det är viktigt
            att vara lyhörd för din kropps reaktioner. Till exempel, om du
            känner oväntad, upprepad eller långvarig smärta, eller trötthet
            eller obehag på grund av att du har gjort ändringar i din sömn eller
            aktivitet, rekommenderas att du rådfrågar en läkare innan du
            fortsätter med sådana förändringar. Informationen i tjänsterna kan
            vara vilseledande om dina fysiologiska funktioner och svar skiljer
            sig väsentligt från befolkningens genomsnitt på grund av medicinska
            tillstånd eller sällsynta naturliga skillnader.
          </TypographyV3>
          <TypographyV3>
            Var försiktig så att produkten du bär inte fastnar i fasta
            strukturer eller tunga föremål. Ta omedelbart bort den om du
            upplever rodnad eller hudirritation på fingret när du bär produkten.
            Om symtomen kvarstår längre än 2-3 dagar efter att produkten inte
            använts, kontakta en läkare.
          </TypographyV3>
          <TypographyV3>
            Vår produkt bör inte vid något tillfälle placeras i munnen. Ouras
            produkt är inte en leksak och är inte heller avsedd att användas av
            barn. Barn bör inte lämnas utan uppsikt med denna produkt, eftersom
            den kan utgöra en kvävningsrisk.
          </TypographyV3>
          <TypographyV3>
            Tjänsterna kan tillhandahålla länkar till andra webbplatser som
            underhålls av tredje part. Du bekräftar och samtycker till att
            sådana länkar endast tillhandahålls för din bekvämlighet och inte
            återspeglar något stöd, anknytning, relation eller sponsring av Oura
            med avseende på leverantören av en sådan länkad webbplats eller
            kvaliteten, tillförlitligheten eller någon annan egenskap eller
            funktion hos en sådan länkad webbplats. Du bekräftar och samtycker
            vidare till att Oura inte är ansvarigt på något sätt (inklusive men
            inte begränsat till eventuell förlust eller skada som du kan lida)
            för någon fråga som är associerad med den länkade webbplatsen,
            inklusive men inte begränsat till innehållet som tillhandahålls på
            eller genom en sådan länkad webbplats eller ditt beroende av den.
            Dessutom bör du vara medveten om att din användning av en tredje
            parts webbplats omfattas av de villkor och bestämmelser som gäller
            för den webbplatsen, inklusive integritetspolicyn (eller bristen på
            en sådan) för en sådan webbplats. Om en tredje part länkar till
            tjänsterna är det inte nödvändigtvis en indikation på stöd,
            anknytning, relation eller sponsring av eller med Oura. Oura kanske
            inte ens är medveten om att en tredje part har länkat till
            tjänsterna.
          </TypographyV3>
          <TypographyV3>
            Allt annat innehåll som inte ägs av Oura ägs av dess respektive
            ägare. Du bekräftar och godkänner att sådant innehåll tillhandahålls
            av dess ägare och inte återspeglar något stöd, anknytning, relation
            eller sponsring av Oura med avseende på leverantören av sådant
            innehåll. Du bekräftar och samtycker vidare till att Oura inte är
            ansvarigt på något sätt (inklusive utan begränsning med avseende på
            eventuell förlust eller skada som du kan lida) för innehåll som
            tillhandahålls av tredje part inklusive, utan begränsning, din
            tillit till detta. OURA LÄMNAR INGA GARANTIER ELLER UTFÄSTELSER MED
            AVSEENDE PÅ TREDJE PARTS INNEHÅLL.
          </TypographyV3>
          <TypographyV3>
            Du samtycker till att gottgöra, hålla oskadlig och försvara Oura,
            dess dotterbolag, närstående företag, tjänstemän, direktörer,
            anställda, representanter, agenter, partner, licensgivare,
            efterträdare och överlåtare, från och mot alla åtgärder, orsaker,
            anspråk , skada, skuld, krav eller ansvar, inklusive rimliga
            kostnader och advokatarvoden, som åberopas av någon person, som
            härrör från eller relaterar till (i) din användning av tjänsterna,
            inklusive men inte begränsat till någon som använder ditt konto
            eller dina inloggningsuppgifter; (ii) brott mot detta avtal av dig
            eller någon som använder ditt konto eller dina inloggningsuppgifter;
            (iii) all information som används, lagras eller överförs i samband
            med ditt konto eller inloggningsuppgifter; (iv) brott mot tredje
            parts rättigheter, inklusive men inte begränsat till integritet,
            publicitet, immateriell egendom eller andra äganderätter av dig
            eller någon som använder ditt konto eller dina uppgifter; eller (v)
            brott mot någon lag, förordning eller andra juridiska krav.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Meddelande till användare i Kalifornien
          </TypographyV3>
          <TypographyV3>
            Enligt California Civil Code Section 1789.3 har användare av
            tjänsterna i Kalifornien rätt till följande specifika meddelande om
            konsumenträttigheter:
          </TypographyV3>
          <TypographyV3>
            Du kan skriftligen kontakta Complaint Assistance Unit of the
            Division of Consumer Services i California Department of Consumer
            Affairs på 1625 N. Market Blvd., Suite N 112, Sacramento,
            Kalifornien 95834, eller per telefon på (800) ) 952-5210.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Uppsägning; Annullering
          </TypographyV3>
          <TypographyV3>
            Detta avtal ska fortsätta att gälla tills det sägs upp eller upphävs
            i enlighet med avtalsvillkoren.
          </TypographyV3>
          <TypographyV3>
            Oura ska ha rätt att säga upp detta avtal (i) oavsett vilken
            anledning genom att ge dig trettio (30) dagars varsel; (ii)
            omedelbart för ditt väsentliga brott mot detta avtal, annat än
            utebliven betalning av avgifter; eller (iii) för utebliven betalning
            av avgifter. Oavsett det föregående förbehåller sig Oura rätten att,
            efter eget gottfinnande och utan föregående meddelande, när som
            helst och av vilken anledning som helst, ta bort, modifiera, avbryta
            eller inaktivera åtkomst till hela eller delar av tjänsterna.
          </TypographyV3>
          <TypographyV3>
            Du kan säga upp avtalet av vilken anledning som helst genom att
            meddela Oura med trettio (30) dagars varsel genom att besöka
            support.ouraring.com/sv och öppna ett supportärende. Du är ansvarig
            för alla avgifter som uppkommit före och under uppsägningstiden. .
          </TypographyV3>
          <TypographyV3>
            Avsnitt med följande rubriker Försiktighetsåtgärder, Immateriella
            rättigheter, Data och kommunikation, Skadeersättning,
            Garantifriskrivning, Ansvarsbegränsning, Tillämplig lag, Forum;
            Obligatorisk bindande skiljedom; Avstående från grupptalan och
            betalningsförpliktelser för avgifter som uppkommit före och under en
            uppsägningstid ska fortsätta att gälla vid uppsägning av detta avtal
            oavsett anledning.
          </TypographyV3>
          <TypographyV3>
            Den federala regeringens begränsningar för slutanvändning
          </TypographyV3>
          <TypographyV3>
            Om du är en amerikansk federal myndighet eller ett organ eller
            tecknar avtal på uppdrag av en sådan myndighet eller organ, är
            tjänsterna "kommersiella föremål" som den termen definieras i 48 CFR
            §2.101, bestående av en "kommersiell datorprogramvara" och en
            "kommersiell datorprogramdokumentation", eftersom dessa termer
            används i 48 CFR §12.212 eller 48 CFR §227.7202. I enlighet med 48
            CFR §12.212 eller 48 CFR §227.7202-1 till 227.7202-4, beroende på
            vad som är tillämpligt, licensieras tjänsten till dig med endast de
            rättigheter som tillhandahålls under villkoren i detta avtal. Om du
            är en federal amerikansk beställningsaktivitet i USA, eller anställd
            av sådan beställningsaktivitet som handlar genom ett GSA
            Schedule-kontrakt i egenskap av agent för en sådan
            beställningsverksamhet, kan villkoren i detta publicerade avtal och
            integritetspolicyn skilja sig åt.
          </TypographyV3>
          <TypographyV3>
            Exportreglering och användningsbegränsningar
          </TypographyV3>
          <TypographyV3>
            Du kommer inte direkt eller indirekt exportera eller återexportera
            tjänsterna, eller någon teknisk information relaterad till dem, till
            en destination eller person till vilken export är förbjuden eller
            begränsad av tillämplig lag, inklusive, utan begränsning, alla
            tillämpliga amerikanska exportkontrollagar och föreskrifter.
          </TypographyV3>
          <TypographyV3>
            Tillämplig lag; Forum; Obligatorisk bindande skiljedom, Avstående
            från grupptalan
          </TypographyV3>
          <TypographyV3>
            Alla åtgärder relaterade till detta avtal, tjänsterna och din
            relation med Oura ska styras av, förstås och tolkas i enlighet med
            lagarna i delstaten Kalifornien utan hänsyn till dess principer om
            lagkonflikter OCH KOMMER SÄRSKILT INTE ATT STYRAS AV FÖRENTA
            NATIONERNAS KONVENTION ANGÅENDE AVTAL OM INTERNATIONELLA KÖP AV
            VAROR, OM ANNAT ÄR TILLÄMPLIGT. Du samtycker till att lösa
            eventuella tvister eller anspråk som uppstår ur eller är relaterade
            till detta avtal eller tjänsterna genom slutlig och bindande
            skiljedom av en enda skiljeman. Detta inkluderar tvister som uppstår
            ur eller är relaterade till tolkning eller tillämpning av denna
            "obligatoriska skiljedomsbestämmelse", inklusive dess
            verkställbarhet, återkallbarhet eller giltighet. Oavsett det
            föregående kan endera parten väcka talan enbart för föreläggande för
            att stoppa obehörig användning eller missbruk av tjänsterna, eller
            kränkning av någon immateriell egendom. Med förbehåll för den
            obligatoriska skiljedomsbestämmelsen, samtycker parterna
            oåterkalleligt till att väcka talan för att lösa eller driva igenom
            anspråk som uppstår enligt eller är relaterade till detta avtal i de
            federala eller statliga domstolarna i San Francisco, Kalifornien,
            och varje part underkastar sig oåterkalleligen den exklusiva
            jurisdiktionen för sådana domstolar i en sådan stämning, talan eller
            process. Förutom i den utsträckning som är förbjuden enligt
            tillämplig lag, är parterna överens om att alla anspråk eller grund
            för en sådan talan som uppstår ur eller är relaterade till
            användningen av tjänsterna eller detta avtal måste lämnas in inom
            ett (1) år efter att ett sådant anspråk eller en sådan talan
            uppstod, annars kan de aldrig behandlas. Denna paragraf gäller inte
            användare som är bosatta i Europeiska unionen. Om du är en användare
            baserad i Europeiska unionen, ska finsk lag tillämpas på detta avtal
            och de finska domstolarna ska ha exklusiv jurisdiktion att pröva
            tvister som uppstår i samband med detta avtal. Denna bestämmelse ska
            inte gälla konsumenter i länder som kräver att avtal styrs av lokala
            lagar i konsumentens land. Det engelska språket ska styra alla
            dokument, meddelanden och tolkningar av detta avtal. Du samtycker
            också till att avsäga dig rätten att göra anspråk mot Oura som
            representant eller medlem i en grupp eller grupptalan, utom där ett
            sådant avstående är förbjudet enligt lag eller av en domstol som
            anses strida mot allmän ordning.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Övrigt
          </TypographyV3>
          <TypographyV3>
            Du bekräftar att Oura har rätt att övervaka användningen av
            tjänsterna för att säkerställa efterlevnad av avtalet.
          </TypographyV3>
          <TypographyV3>
            Inget avstående från något villkor eller bestämmelse i detta avtal,
            vare sig genom beteende eller på annat sätt, i ett eller flera fall,
            ska anses vara, eller utgöra, ett avstående från något annat villkor
            eller bestämmelse häri, oavsett om det är likartat eller inte, och
            ett sådant avstående ska inte heller utgöra ett fortsatt avstående
            från något sådant villkor eller bestämmelse häri. Inget avstående
            ska vara bindande, såvida det inte verkställs skriftligen av parten
            som gör avståendet.
          </TypographyV3>
          <TypographyV3>
            Du får inte överlåta detta avtal till någon annan part och alla
            försök att göra det är ogiltiga.
          </TypographyV3>
          <TypographyV3>
            Om någon bestämmelse i detta avtal fastställs vara olaglig eller
            omöjlig att verkställa, kommer denna bestämmelse att verkställas i
            största möjliga utsträckning, och de andra bestämmelserna kommer att
            förbli fullt effektiva och verkställbara.
          </TypographyV3>
          <TypographyV3>
            Detta avtal och integritetspolicyn utgör det fullständiga och
            exklusiva överenskommelsen mellan dig och Oura angående tjänsterna
            och ersätter alla tidigare eller samtida kommunikationer,
            framställningar, uttalanden och samförstånd, vare sig muntliga eller
            skriftliga, mellan parterna.
          </TypographyV3>
          <TypographyV3>
            Vid eventuella konflikter mellan villkoren i detta avtal och
            villkoren i integritetspolicyn, ska villkoren i detta avtal gälla.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Ändring av villkoren och tjänsterna
          </TypographyV3>
          <TypographyV3>
            Oura förbehåller sig rätten att uppdatera detta avtal och/eller
            integritetspolicyn när som helst och av vilken anledning som helst
            efter eget gottfinnande genom att publicera uppdaterade villkor. Om
            inget annat anges av Oura, kommer alla ändringar att träda i kraft
            från och med datumet för inlägget. Oura kommer att meddela dig om
            alla väsentliga ändringar i avtalet eller tjänsterna. Genom att
            fortsätta komma åt eller använda tjänsterna efter att vi har
            meddelat dig om en ändring, samtycker du till att vara bunden av det
            ändrade avtalet. Om det ändrade avtalet inte är godtagbart för dig
            är din enda möjlighet att sluta använda tjänsterna. Oura och dess
            tredjepartstjänsteleverantörer kan göra förbättringar och/eller
            ändringar i tjänsterna, funktionerna och priserna som beskrivs när
            som helst och av vilken anledning som helst efter eget gottfinnande.
            Mobilappen kan ladda ner och installera uppgraderingar,
            uppdateringar och ytterligare funktioner för att förbättra och
            vidareutveckla tjänsterna. Oura förbehåller sig rätten att när som
            helst ändra eller avbryta, tillfälligt eller permanent, tjänsterna
            eller någon del därav med eller utan förvarning. Du samtycker till
            att Oura inte ska vara ansvarigt gentemot dig eller någon tredje
            part för någon ändring, avstängning eller avbrott av tjänsterna.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h1">
            ŌURA LEVERANSVILLKOR
          </TypographyV3>
          <TypographyV3>
            <em>Senast uppdaterat: 4 mars 2024</em>
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Kanada och Storbritannien
          </TypographyV3>
          <TypographyV3>
            Oura kommer att leverera produkterna enligt Incoterms
            leveransvillkor levererat förtullat (Delivered Duty Paid, "DDP").
            Oura ansvarar för import och leverans av produkter till angiven
            plats i köparens land. Oura ansvarar för att betala alla kostnader
            relaterade till importen av produkterna till köparens land och
            kommer att ta ut skatt enligt gällande skattesats baserat på
            leveransadressen för produkterna. Oura kommer att utfärda en
            skattefaktura för alla lokala indirekta skatter som ska betalas på
            försäljningen, enligt lokal lagstiftning.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Europeiska unionen och USA
          </TypographyV3>
          <TypographyV3>
            Oura kommer att leverera produkter från lokala distributionscenter
            till den angivna platsen i köparens respektive jurisdiktion. Oura
            kommer att debitera skatt enligt gällande skattesats baserat på
            leveransadressen för produkterna i enlighet med lokala regler.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Utanför länderna som anges ovan
          </TypographyV3>
          <TypographyV3>
            Oura kommer att leverera produkterna enligt Incoterms
            leveransvillkor levererat på angiven plats (Delivered At Place,
            "DAP"), med överlåtelse av äganderätten till köparen omedelbart före
            import. Oura betalar för transporten till angiven plats utanför
            köparens land, men ansvarar inte för att importera produkterna till
            köparens land och leverera produkterna till den angivna platsen i
            köparens land. Köparen står för alla kostnader relaterade till
            importen av produkterna. Oura kommer inte att underlätta
            indrivningen av eventuella skatter för köparens räkning.
          </TypographyV3>
          <TypographyV3>
            Om det förekommer en konflikt mellan den engelska versionen och
            översättningar på andra språk gäller versionen på det engelska
            språket, om inte annat krävs av tillämplig lokal lag.
          </TypographyV3>
        </TypographyRhythm>
      </LayoutGrid>
    </PageLayoutV3>
  );
};

export default Page;
